/* ######################################### */
/* Generate custom select from native select */
/* ######################################### */

let selects = [].slice.call(document.querySelectorAll('select'));
//console.log(selects);

window.coma = window.coma || {};
window.coma.select = { createSelect: createSelect };

//if (window.document.documentMode === undefined && navigator.userAgent.toLowerCase().indexOf('safari') == -1) {
if (window.document.documentMode === undefined) {
  selects.forEach(function(select) {
    createSelect(select);
  });
} else {
  selects.forEach(function(select) {
    select.parentNode.classList.add('select-ie11');
    select.addEventListener('change', function(){
      if (this.hasAttribute('required')) {
        if (this.value.trim() == '' || this.value == undefined) {
          this.parentElement.classList.remove('validation--valid');
          this.parentElement.classList.add('validation--error');
        } else {
          this.parentElement.classList.remove('validation--error');
          this.parentElement.classList.add('validation--valid');
        }
      }
    });
  });
}

function createSelect(select, changeEvent, preselectionId) {
  // console.log(select);
  if (select.classList.contains('no-convert')) {
    return;
  }

  let details = document.createElement('details');
  details.id = select.id + '_detail' || 'select-' + Math.floor(Math.random() * Math.floor(99));;
  details.classList.add('select_container');

  // Summary
  let summary = document.createElement('summary');
  //console.log(select)
  summary.innerHTML = select.firstElementChild.innerHTML;
  details.appendChild(summary);

  // Select Options
  let selectContainer = document.createElement('div');
  selectContainer.classList.add('select');

  // Create markup from options
  let selectOptions = '';
  let options = [].slice.call(select.querySelectorAll('option'));
  options.forEach(function(option) {
    selectOptions += '<label class="select__option"><input type="radio" name="example" value="' + option.value + '">' + option.innerHTML + '</label>'
    //selectOptions += '<label class="select__option">' + option.innerHTML + '</label>'
  });

  selectContainer.innerHTML = selectOptions;
  details.appendChild(selectContainer);

  if(preselectionId) {
    let preselectedElement = selectContainer.querySelector('input[value="' + preselectionId + '"]');
    if(preselectedElement) preselectedElement.checked = true;
  }

  select.parentElement.insertBefore(details, select);
  _syncSelect(select, details, changeEvent);
  initSelect(details);

  // Watch custom select and sync native select
  function _syncSelect(_select, _details, changeEvent) {
    let _options = [].slice.call(_details.querySelectorAll('input[type="radio"]'));

    _options.forEach(function(_option) {
      if (changeEvent !== null) {
        _option.addEventListener('change', changeEvent);
      } else {
        _option.addEventListener('change', function(e) {
          let id = event.target.value;
          _select.value = e.target.value
        });
      }
    });
  }

  select.addEventListener('change', function(){
    if (this.hasAttribute('required')) {
      let buff = document.getElementById(this.id + '_detail');
      if (this.value.trim() == '' || this.value == undefined) {
        buff.classList.remove('parsley-success');
        buff.classList.add('parsley-error');

        this.parentElement.classList.remove('validation--valid');
        this.parentElement.classList.add('validation--error');
      } else {
        buff.classList.remove('parsley-error');
        buff.classList.add('parsley-success');

        this.parentElement.classList.remove('validation--error');
        this.parentElement.classList.add('validation--valid');

        if (this.parentElement.lastElementChild.nodeName.toLowerCase() == 'ul') {
          this.parentElement.lastElementChild.remove();
        }
      }
    }
  });
}


/* ######################################### */
/* Add interactivity for custom select field */
/* ######################################### */

// Credits: https://dev.to/link2twenty/accessibility-first-dropdown-select-3ji5

function initSelect(details) {
  let container = details,
    options = [].slice.call(details.querySelectorAll('.select > .select__option')),
    value = container.querySelector("summary").textContent,
    mouseDown = false;

  _addEventListeners();
  _setAria();
  updateValue();

  // Private function to set event listeners
  function _addEventListeners() {
    container.addEventListener("toggle", function () {
      if (container.open) return;
      updateValue();
    });

    container.addEventListener("focusout", function(e) {
      if (mouseDown) return;
      container.removeAttribute("open");
    });

    options.forEach(function(opt) {
      opt.addEventListener("mousedown", function() {
        mouseDown = true;
      });
      opt.addEventListener("mouseup", function() {
        mouseDown = false;
        container.removeAttribute("open");
      });
    });

    container.addEventListener("keydown", function(e) {
      const keycode = e.which;
      const current = options.indexOf(
        container.querySelector(".active")
      );
      switch (keycode) {
        case 27: // ESC
          container.removeAttribute("open");
          break;
        case 35: // END
          e.preventDefault();
          if (!container.open) container.setAttribute("open", "");
          self.setChecked(
            options[options.length - 1].querySelector("input")
          );
          break;
        case 36: // HOME
          e.preventDefault();
          if (!container.open) container.setAttribute("open", "");
          setChecked(options[0].querySelector("input"));
          break;
        case 38: // UP
          e.preventDefault();
          if (!container.open) container.setAttribute("open", "");
          setChecked(
            options[current > 0 ? current - 1 : 0].querySelector("input")
          );
          break;
        case 40: // DOWN
          e.preventDefault();
          if (!container.open) container.setAttribute("open", "");
          setChecked(
            options[
              current < options.length - 1
                ? current + 1
                : options.length - 1
              ].querySelector("input")
          );
          break;
      }
    });
  }

  function _setAria() {
    container.setAttribute("aria-haspopup", "listbox");
    container.querySelector(".select").setAttribute("role", "listbox");
    const summary = container.querySelector("summary");
    summary.setAttribute("aria-label", 'unselected listbox');
    summary.setAttribute("aria-live", 'polite');
    options.forEach(function(opt) {
      opt.setAttribute("role", "option");
    });
  }

  function updateValue(e) {
    const that = container.querySelector("input:checked");
    if (!that) return;
    setValue(that);
  }

  function setChecked(that) {
    that.checked = true;
    setValue(that);
  }

  function setValue(that) {
    if (value == that.value) return;

    const summary = container.querySelector("summary");
    const pos = options.indexOf(that.parentNode) + 1;
    summary.textContent = that.parentNode.textContent;
    summary.setAttribute("aria-label", that.value + ', listbox ' + pos + ' of ' + options.length);
    value = that.value;

    options.forEach(function(opt) {
      opt.classList.remove("active");
      opt.setAttribute("aria-selected", "false");
    });
    that.parentNode.classList.add("active");
    that.parentNode.setAttribute("aria-selected", "true");

    let event;
    if(typeof(Event) === 'function') {
      event = new Event('change');
    }else{
      event = document.createEvent('Event');
      event.initEvent('change', true, true);
    }

    let selectId = container.getAttribute('id').replace('_detail', '');
    let select = document.getElementById(selectId);
    if (select !== null) {
      for (let i=0, len = select.options.length; i < len; i++) {
        if (select.options[i].value == value) {
          select.options[i].setAttribute('selected', 'selected');
        } else {
          select.options[i].removeAttribute('selected');
        }
      }
      select.dispatchEvent(event);
    }

    container.dispatchEvent(event);
  }
}